import { ImmutabilityContext } from '../effects/customImmutabilityContext';
import { PostEditorBulkImportSetLinksMetadataAction, PostEditorReducerFunction } from '../PostEditorActions';
import { GroupPostAttributesType, PostEditorState, PostGroupsType } from '../../../../models/post-editor';

const getMappedLinkWithMetadata = (
  post: GroupPostAttributesType,
  linkMetadata: PostEditorBulkImportSetLinksMetadataAction['payload']
) => {
  const postLink = post.content.link;
  if (!postLink) return post;
  const mappedLinkMetadata = linkMetadata.find(metadataLink => metadataLink.initialUrl === postLink.initialUrl);
  if (!mappedLinkMetadata) return post;
  const { update: updateImmutable } = ImmutabilityContext;
  return updateImmutable<GroupPostAttributesType>(post, {
    content: {
      link: currentLink => (currentLink ? { ...currentLink, linkMetadata: mappedLinkMetadata } : currentLink)
    }
  });
};
export const bulkImportSetLinkMetadataReducer: PostEditorReducerFunction<
  PostEditorBulkImportSetLinksMetadataAction['payload']
> = (state, payload) => {
  const { update: updateImmutable } = ImmutabilityContext;
  return updateImmutable<PostEditorState>(state, {
    postGroups: currentGroup =>
      currentGroup.map(group =>
        updateImmutable<PostGroupsType>(group, {
          posts: currentPosts =>
            currentPosts.map(post => {
              return getMappedLinkWithMetadata(post, payload);
            }),
          groupPostAttributes: currentGroup => getMappedLinkWithMetadata(currentGroup, payload)
        })
      )
  });
};
